const EN_CONTENT = Object.freeze({
  model: 'M1',
  heroTitle: 'M1 body composition analyzer'
})

const ZH_CONTENT = Object.freeze({
  model: 'P1',
  navTitle: 'Anovator P1',
  demoLabel: 'Request demo',
  heroKicker: '科技革新',
  heroTitle: '为颠覆而生',
  heroSubtitle: 'Intelligent multi-function human body analyzer',
  scrollLabel: 'Scroll Mouse',
  functionsTitle: '专业智能体测仪',
  functionsDescription: '助力场馆数据化运营',
  functions: ['平衡评估', '体态围度评估', '5节段肌肉与脂肪分析', '人体成分分析'],
  bodyMetrics: ['脂肪', '水分', '蛋白质', '肌肉率', '基础代谢', 'BMI', '骨量', '内脏脂肪'],
  postureRisks: ['高低肩', '驼背', '骨盆前倾', '膝超伸', 'O型腿', '脊柱侧弯', '头侧倾', '更多体态检测'],
  comparisonModels: [
    { model: 'P1', image: '/static/images/product/m1-black.png' },
    { model: 'P3', image: '/static/images/product/p3/compare-p3.png' }
  ],
  comparisonRows: [
    ['Body Composition Analysis', true, true],
    ['Posture & Body Dimension Analysis', true, true],
    ['Exercise Safety Assessment', false, true],
    ['Cardiorespiratory Assessment', false, true],
    ['Agility & Reaction Assessment', false, true],
    ['Balance Assessment', true, true],
    ['Lower-Body Power Assessment', false, true],
    ['Upper-Body Power Assessment', false, true],
    ['Grip Strength Assessment', false, true],
    ['Lung Capacity Assessment', false, true],
    ['Shoulder Range of Motion Assessment', false, true],
    ['Frequencies', '20kHz；100kHz；250kHz', '20kHz；100kHz；250kHz'],
    ['Display', '21.5-inch Full HD Display', '32-inch 2K Bonded Display'],
    ['Working Distance', '1m', '1.5m']
  ],
  disclaimer: [
    '以上页面中的产品图片及屏幕内容仅作示意，产品实际外观（包括但不限于颜色、尺寸、设计细节）与显示内容（包括但不限于背景、界面、图形效果）可能存在差异，一切请以实物为准。',
    '以上页面所呈现的全部数据，均为 ANOVATOR 或其合作实验室在特定测试条件下（详见各单项说明）通过内部测试得出的理论值。受产品个体差异、软件版本、使用条件及环境因素影响，实际使用效果可能有所不同，一切请以实际使用情况为准。',
    '为尽可能提供准确的产品信息、规格及功能，ANOVATOR 可能会对以上页面中的文字说明、图片等内容进行实时调整与修订，确保与产品实际性能、规格、指标及部件保持一致。因产品批次及供货条件变化，此类修改可能不会提前另行通知。'
  ]
})

function getM1ProductContent(language) {
  return language === 'ZH' ? ZH_CONTENT : EN_CONTENT
}

module.exports = {
  EN_CONTENT,
  ZH_CONTENT,
  getM1ProductContent
}
